"use client";

import { FC } from "react";

type CartButtonProps = {
  itemCount: number;
  onClick: () => void;
  onMouseEnter?: () => void;
  onMouseLeave?: () => void;
};

// `data-cart-button` (used to be a click-forwarding target for nav
// components + a hover-preload DOM query in cart.tsx) is gone — spec §E
// step 1.3 replaced both with direct `openUtility()` calls / hover props.
const CartButton: FC<CartButtonProps> = ({ itemCount, onClick, onMouseEnter, onMouseLeave }) => (
  <button
    onClick={onClick}
    onMouseEnter={onMouseEnter}
    onMouseLeave={onMouseLeave}
    className="relative flex items-center justify-center w-8 h-8"
    aria-label="Open cart"
  >
    {/* YOUR ORIGINAL CART SVG */}
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="h-8 w-8"
      viewBox="0 0 24 24"
    >
      <circle cx="8" cy="21" r="1" />
      <circle cx="19" cy="21" r="1" />
      <path d="M2.05 2.05h2l2.66 12.42a2 2 0 0 0 2 1.58h9.78a2 2 0 0 0 1.95-1.57l1.65-7.43H5.12" />
    </svg>

    {itemCount > 0 && (
      <span
        className="absolute top-0 right-0 inline-flex items-center justify-center
                   px-1.5 py-0.5 text-xs font-semibold leading-none text-white
                   bg-red-600 rounded-full transform translate-x-1/2 -translate-y-1/2"
      >
        {itemCount}
      </span>
    )}
  </button>
);

export default CartButton;
